import React from 'react';

/**
 * A conditional renderer helper
 * */
type ShowProps = {
  children: React.ReactNode;
  when: boolean;
  fallback: React.ReactNode;
};

const Show = ({ children, when, fallback }: ShowProps) => {
  if (when) return <>{children}</>;

  return <>{fallback}</>;
};

export { Show };
